module.exports = __webpack_public_path__ + "static/media/laptop.091f0aa0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/laptop.svg
// module id = 1487
// module chunks = 0